<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import type { AsTag, PrimitiveProps } from "reka-ui";
import type { ButtonVariants } from ".";
import type { Component, HTMLAttributes } from "vue";
import { RouterLink } from "vue-router";
import { computed } from "vue";
import { Primitive } from "reka-ui";
import { cn } from "@/lib/utils";
import { buttonVariants } from ".";

export interface Props extends PrimitiveProps {
  variant?: ButtonVariants["variant"];
  size?: ButtonVariants["size"];
  class?: HTMLAttributes["class"];
  to?: string | RouteLocationRaw;
  href?: string;
}

const props = defineProps<Props>();

const as = computed<AsTag | Component>(() => {
  if (props.href) return "a";
  if (props.to) return RouterLink;
  return props.as || "button";
});

const rel = computed<string | undefined>(() => {
  if (props.href && props.href.startsWith("http")) {
    return "noopener";
  }

  return undefined;
});
</script>

<template>
  <Primitive
    data-slot="button"
    :rel
    :as="as"
    :as-child="asChild"
    :to
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <slot />
  </Primitive>
</template>
